import { type ICountry } from '@mahawi/eshop-common/src/types';
import { createSlice } from '@reduxjs/toolkit';

import {
  requestFailedMatcher,
  resetLoadingOnRequestFailed,
} from '../async-state';
import { type ICountryState } from './types';

export const preloadedState: ICountryState = {
  inProcess: false,
  country: undefined,
};

const countrySlice = createSlice({
  name: 'Country',
  initialState: preloadedState,
  reducers: {
    countryLoad: {
      reducer(state) {
        state.inProcess = true;
        state.country = undefined;
      },
      prepare(isoCode: string) {
        return { payload: { isoCode } };
      },
    },
    countryLoadResponse: {
      reducer(state, action: { payload: { country: ICountry | null } }) {
        state.inProcess = false;
        state.country = action.payload.country;
      },
      prepare(country: ICountry | null) {
        return { payload: { country } };
      },
    },
    countrySaveCurrency: {
      reducer(state) {
        state.inProcess = true;
      },
      prepare(isoCode: string, currencyIsoCode: string) {
        return { payload: { isoCode, currencyIsoCode } };
      },
    },
    countrySaveOriginCurrency: {
      reducer(state) {
        state.inProcess = true;
      },
      prepare(isoCode: string, currencyIsoCode: string | null) {
        return { payload: { isoCode, currencyIsoCode } };
      },
    },
    countrySaveDescription: {
      reducer(state) {
        state.inProcess = false;
      },
      prepare(isoCode: string, description: string) {
        return { payload: { isoCode, description } };
      },
    },
    countrySaveDeliveryDescription: {
      reducer(state) {
        state.inProcess = true;
      },
      prepare(isoCode: string, deliveryDescription: string) {
        return { payload: { isoCode, deliveryDescription } };
      },
    },
    countrySaveDeliveryTime: {
      reducer(state) {
        state.inProcess = false;
      },
      prepare(isoCode: string, deliveryTime: number) {
        return { payload: { isoCode, deliveryTime } };
      },
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      requestFailedMatcher('Country'),
      resetLoadingOnRequestFailed,
    );
  },
});

export const {
  countryLoad,
  countryLoadResponse,
  countrySaveCurrency,
  countrySaveOriginCurrency,
  countrySaveDescription,
  countrySaveDeliveryDescription,
  countrySaveDeliveryTime,
} = countrySlice.actions;
export default countrySlice.reducer;
